import { render, staticRenderFns } from "./Provinces.vue?vue&type=template&id=17fe7042"
import script from "./Provinces.vue?vue&type=script&lang=js"
export * from "./Provinces.vue?vue&type=script&lang=js"
import style0 from "./Provinces.vue?vue&type=style&index=0&id=17fe7042&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports